// extracted by mini-css-extract-plugin
export default {"Container":"TranslationFilter_Container__O15Ri"};